import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams, useLocation } from "react-router-dom";
import { setAlertMessageSnackbarMessageSeverity, setAlertMessageSnackbarMsg, setAlertMessageSnackbarOpen, setLoading } from "../store/feedback";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Box } from "@mui/material";
// import Topbar from "../components/Topbar";
// import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import data from "./image_category.json";
import moment from "moment";
import imageUrls from './imageUrls.json';
import { SnackbarAlert } from "./AlertMessage";
import { callAddFont } from './Mulish-SemiBold-normal'
import { callAddFontMulishRegular } from './Mulish-Regular-normal'
import { callAddFontMediumItalic } from "./Mulish-MediumItalic-normal";
import QRCode from 'qrcode';
// import { Worker, Viewer } from '@react-pdf-viewer/core';
// import '@react-pdf-viewer/core/lib/styles/index.css';
// import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { toast } from 'react-toastify';
const ProcessedResult = () => {
    // const {
    //     selectedAudit
    // } = useSelector(state => state.miAuditSearchStore);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const selectedAudit = queryParams.get('audit');
    // const { audit_id } = useParams();
    const audit_id = selectedAudit;
    const [result, setResult] = useState([]);
    let [bodyType, setBodyType] = useState("SUV");
    const [auditDetails, setAuditDetails] = useState(null);
    const [auditInfo, setAuditInfo] = useState(null);
    const [pdfGenerated, setPdfGenerated] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [notAnnotated, setNotAnnotated] = useState(false)
    const dispatch = useDispatch();
    const targetRef = useRef();
    const [recommendation, setRecommendation] = useState("YES");
    const [pdfUrl, setPdfUrl] = useState('');
    const [locationDetails, setLocationDetails] = useState({ latitude: null, longitude: null, license_plate: null });
    const [locationMatch, setLocationMatch] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                dispatch(setLoading(true));
                const res = await axios.post("/process_data/get_audit_info", { audit_id: audit_id });
                // console.log("51", res.data);
                // console.log(res.data[0].image_name);

                const res1 = await axios.post("/create_audit/audit-detail", { audit_id: audit_id })
                setAuditInfo(res1.data[0]);
                // Fetch audit details metadata
                // console.log(audit_id);

                const uploadUrl = `https://caiproduction002.blob.core.windows.net/ira/insurance-inspection-details/${audit_id}.json`;
                const sasToken = '?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D';
                const auditDetailsMetadata = await axios.get(`${uploadUrl}${sasToken}`, { responseType: "json" });
                setAuditDetails(auditDetailsMetadata.data);

                const bodyTypeRes = await axios.post("/process_data/getBodyType", {
                    "make": auditDetailsMetadata.data["Make"],
                    "model": auditDetailsMetadata.data["Model"]
                });
                // console.log(bodyTypeRes.data);
                if (bodyTypeRes.data) {
                    setBodyType(bodyTypeRes.data["vehicle_body_type_description"]);
                }
                else {
                    setBodyType("---");
                }
                const sortedData = res.data.sort((a, b) => {
                    return a.type - b.type;
                });
                // Set the sorted result data to the state
                setResult(sortedData);
                setLocationDetails((prev) => ({
                    ...prev,
                    latitude: sortedData[0].latitude,
                    longitude: sortedData[0].longitude
                }));
                // console.log(sortedData, "77")
                dispatch(setLoading(false));
            } catch (err) {
                console.log(err);
            }
        };
        fetchData();
    }, []);

    // useEffect(() => {
    // 	if (result.length > 0 && !pdfGenerated) {
    // 		downloadPDF(result);
    // 		setPdfGenerated(true);
    // 	}
    // }, [result, pdfGenerated]);
    //  console.log(auditInfo,"84")

    const fetchTableData = async () => {
        try {
            const res = await axios.get("/process_data/fetch_classes");
            // console.log(res);

            let mergedResult;
            if (result) {
                const data = result.filter((res) => {
                    if (res.type === "1" || res.type === "3" || res.type === "5" || res.type === "7") {
                        return res;
                    }
                })

                const containsKey = (obj, keys) => keys.some(key =>
                    Object.keys(obj).some(objKey => objKey.toLowerCase().includes(key))
                );
                // console.log("98",containsKey);

                const extractRelevantData = (data, keys) => {
                    // console.log("101",data,keys);
                    return data.map(item => {
                        const relevantResults = item.result.filter(res => containsKey(res, keys));
                        // console.log('104',relevantResults);						
                        return relevantResults;
                    }).flat();
                };

                const mergeObjectsWithUniqueKeys = (objectsArray) => {
                    return objectsArray.reduce((acc, obj) => {
                        Object.keys(obj).forEach(key => {
                            if (!acc[key]) {
                                acc[key] = obj[key];
                            }
                        });
                        return acc;
                    }, {});
                };;

                const relevantKeys = ["front", "left", "rear", "right"];
                const processedData = extractRelevantData(data, relevantKeys);
                // console.log("122",processedData);
                mergedResult = mergeObjectsWithUniqueKeys(processedData);
                //   console.log(Object.keys(mergedResult).length,"95")
                //   console.log("125",mergedResult);
            }
            const data = res.data.map(item => ["--", item.name]);
            const types = ["Intact", "Scratch", "Broken", "Dent"];
            const matchedIndexes = data.map(([defaultType, name]) => {
                // console.log(name,defaultType,"130")
                const value = mergedResult[name];
                // console.log(value ,"132")
                let typeIndex = types.indexOf(value);
                // console.log(typeIndex,"109")
                if (typeIndex === -1) {
                    typeIndex = "---";
                }
                return [name, typeIndex]; // Storing name and typeIndex in an array
            });
            //   console.log(matchedIndexes,"140")
            return matchedIndexes;
        } catch (err) {
            console.log(err);
            return []
        }
    };

    // const fetchPartDetails = async (audit_id) => {
    // 	try {
    // 		const response = await fetch(`/process_data/fetchPartDetails/${audit_id}`);
    // 		const data = await response.json();

    // 		if (response.ok && data.partDetail) {
    // 			// If partDetail is in string format, parse it
    // 			const partDetails = JSON.parse(data.partDetail);
    // 			// console.log("172", partDetails);

    // 			// Check for Scratch, Broken, or Dent being 1 and set recommendation
    // 			let hasIssues = false;

    // 			Object.values(partDetails).forEach((condition) => {
    // 				if (condition.Scratch === 1 || condition.Broken === 1 || condition.Dent === 1) {
    // 					hasIssues = true;
    // 				}
    // 			});

    // 			// Update recommendation based on whether issues are found
    // 			setRecommendation(hasIssues ? "NO" : "YES");
    // 			// console.log("203", recommendation);
    // 			return partDetails;
    // 		} else {
    // 			console.error("No part details found");
    // 		}
    // 	} catch (error) {
    // 		console.error("Error fetching part details:", error);
    // 	}
    // };

    const fetchPartDetails = async (audit_id) => {
        try {
            const response = await fetch(`/process_data/fetchPartDetails/${audit_id}`);
            const data = await response.json();

            if (response.ok && data.partDetail) {
                // Parse partDetail if it's in string format
                const partDetails = JSON.parse(data.partDetail);

                // Check for Scratch, Broken, or Dent being 1 and set recommendation
                let hasIssues = false;
                Object.values(partDetails).forEach((condition) => {
                    if (condition.Scratch === 1 || condition.Broken === 1 || condition.Dent === 1) {
                        hasIssues = true;
                    }
                });

                // Update recommendation based on whether issues are found
                setRecommendation(hasIssues ? "NO" : "YES");

                return {
                    partDetails,
                    frontLeftTyreNo: data.frontLeftTyreNo,
                    backLeftTyreNo: data.backLeftTyreNo,
                    backRightTyreNo: data.backRightTyreNo,
                    frontRightTyreNo: data.frontRightTyreNo,
                    chassisNo: data.chassisNo,
                    odometer: data.odometer,
                    rc: data.rc,
                    LicenseNo: data.LicenseNo,
                };
            } else {
                console.error("No part details found");
            }
        } catch (error) {
            console.error("Error fetching part details:", error);
        }
    };

    useEffect(() => {
        if (audit_id) {
            fetchPartDetails(audit_id);
        }
    }, [audit_id]);

    const fetchFraudCode = async (auditID, imageName) => {
        // const auditID = "LWM617112433";
        // const imageName = "LWM617112433_front_side_captured_image.jpeg";
        try {
            const response = await axios.get("/process_data/fraud-code", {
                params: {
                    auditID,
                    image_name: imageName,
                },
            });
            console.log('Fraud Code:', response.data);
        } catch (error) {
            console.error('Error fetching fraud code:', error);
        }
    };
    // useEffect(() => {
    //     fetchFraudCode();
    // }, [])

    // useEffect(()=>{
    //  if(locationDetails.latitude && locationDetails.longitude && locationDetails.license_plate)
    //  {
    //    const call_func=async()=>{
    //     try{
    //         const res = await axios.post("/locationSwap/checkLocation",{plate:locationDetails.license_plate,lat:locationDetails.latitude,lng:locationDetails.longitude})
    //         console.log(res.data)
    //         setLocationMatch(res?.data.match);
    //     }
    //     catch(err){
    //         console.log(err,"error")
    //     }

    //    }
    //    call_func();
    //  }
    // },[locationDetails])
    const loadImageData = async (imageUrl) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "Anonymous";
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                const imageData = canvas.toDataURL('image/jpeg');
                resolve(imageData);
            };
            img.onerror = (error) => {
                reject(error);
            };
            img.src = imageUrl;
        });
    };




    const compressImage = (imageElement, maxWidth, maxHeight, quality = 1) => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const originalWidth = imageElement.width;
        const originalHeight = imageElement.height;

        let { width, height } = imageElement;

        if (width > height) {
            if (width > maxWidth) {
                height *= maxWidth / width;
                width = maxWidth;
            }
        } else {
            if (height > maxHeight) {
                width *= maxHeight / height;
                height = maxHeight;
            }
        }

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(imageElement, 0, 0, width, height);

        const scaleX = width / originalWidth;
        const scaleY = height / originalHeight;
        return {
            imageDataUrl: canvas.toDataURL("image/jpeg", quality),
            scaleX,
            scaleY
        };
    };

    const processImages = async (imageElement) => {
        const maxWidth = 1500;
        const maxHeight = 1500;
        const quality = 1;

        const compressedImage = compressImage(imageElement, maxWidth, maxHeight, quality);
        // const compressedImage2 = compressImage(imageElement2, maxWidth, maxHeight, quality);

        const img = new Image();
        img.src = compressedImage.imageDataUrl;
        // const img2 = new Image();
        // img2.src = compressedImage2.imageDataUrl;

        await Promise.all([
            new Promise((resolve) => (img.onload = resolve))
        ]);

        return [{ img: img, scaleX: compressedImage.scaleX, scaleY: compressedImage.scaleY }]
    };

    const getLocation = async (latitude, longitude) => {
        const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
        try {
            const response = await fetch(url);
            const data = await response.json();
            // console.log("309",data);

            if (data && data.address) {
                return data.address
                // setLocation(data.display_name);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const get_image_url = (image) => {
        return `https://caisdatahouse.blob.core.windows.net/insurance-inspection/auditImages/${image}?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D`;
    };
    const get_image_url_ai = (image) => {
        return `https://caisdatahouse.blob.core.windows.net/insurance-inspection/aiProcessedImages/${image}?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D`
    };

    const drawPinkBorders = (pdf) => {
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = 25;
        const borderHeight = 5; // Height of the top border
        const borderWidth = 5;  // Width of the vertical borders
        const borderColor = [255, 0, 134]; // RGB color for pink

        // Draw the pink border at the top of each page
        pdf.setFillColor(...borderColor);
        pdf.rect(0, 0, pageWidth, borderHeight, 'F'); // Top border

        // Draw the pink border on the left side
        pdf.rect(0, 0, 5, 25, 'F'); // Left vertical border

        // Draw the pink border on the right side
        pdf.rect(pageWidth - borderWidth, 0, borderWidth, pageHeight, 'F'); // Right vertical border
    };


    function addHeaderToPDF2(pdf, auditDetails) {
        pdf.addImage("/inspection-images/surveyors-icon.png", 14, 11, 35, 11)
        pdf.setFontSize(14);
        pdf.setFont("Mulish-SemiBold", 'normal')
        pdf.text("Inspection report", 14, 27);
        const subHeadingText1 = ` Insurance Company: ${auditDetails['Insurance Company']} `;
        const subHeadingText2 = ` Powered By: ${auditDetails['Powered By']}`;
        pdf.setFontSize(12);
        pdf.setFont("Mulish-Regular", 'normal');
        pdf.text(subHeadingText1, 95, 19);
        pdf.setFontSize(10);
        pdf.setFont("Mulish-MediumItalic", 'normal')
        pdf.text(subHeadingText2, 95, 25);
    }

    const downloadUrl1 = `https://caisdatahouse.blob.core.windows.net/insurance-inspection/auditVideos/${audit_id}_rpm_meter_video.mp4?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D`;

    async function addHeaderToPDF(pdf, auditDetails, downloadUrl) {
        // Add surveyors logo
        pdf.addImage("/inspection-images/surveyors-icon.png", 14, 9, 35, 11);

        // Set heading fonts and text
        pdf.setFontSize(14);
        pdf.setFont("Mulish-SemiBold", 'normal');
        pdf.text("Inspection report", 14, 25);

        // Add sub-heading details
        const subHeadingText1 = ` Insurance Company: ${auditDetails['Insurance Company']} `;
        const subHeadingText2 = ` Powered By: ${auditDetails['Powered By']}`;
        pdf.setFontSize(11);
        pdf.setFont("Mulish-Regular", 'normal');
        pdf.text(subHeadingText1, 70, 19);

        pdf.setFontSize(9);
        pdf.setFont("Mulish-MediumItalic", 'normal');
        pdf.text(subHeadingText2, 70, 25);

        // Generate a QR code for the download URL
        const qrCodeDataUrl = await QRCode.toDataURL(downloadUrl);

        // Add the generated QR code to the PDF
        pdf.addImage(qrCodeDataUrl, 'PNG', 150, 9, 20, 20);

        pdf.addImage("/inspection-images/video-icon.png", 181, 10, 9, 9);

        // Add "Click here" on the first line and "to download the video" on the second line
        pdf.setFontSize(7);
        pdf.setFont("Mulish-Regular", 'normal');
        pdf.setTextColor(255, 0, 131);
        pdf.text("Click here to", 179, 23);
        pdf.text("download the video", 175, 27);

        // Draw underline for both lines of text
        pdf.setDrawColor(255, 0, 131); // Pink color for the underline
        pdf.line(179, 24, 194, 24);  // Underline "Click here to"
        pdf.line(175, 28, 198, 28);  // Underline "download the video"

        pdf.setTextColor(0, 0, 0);
        pdf.link(175, 20, 50, 15, { url: downloadUrl1 });
    }
    const blobName = `downloadedPdf/${audit_id}.pdf`;
    const link_to_pdf = audit => {
        const pdfUrl = `https://caisdatahouse.blob.core.windows.net/insurance-inspection/${blobName}?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D`;
        // console.log(pdfUrl);
        setPdfUrl(pdfUrl);
        return pdfUrl;
    };
    const TICK_ICON_PATH = `${process.env.PUBLIC_URL}/inspection-images/tick.png`;
    const DAMAGE_ICON_PATH = `${process.env.PUBLIC_URL}/inspection-images/damage-icon.png`;
    const formatVehicleDetails = (data) => {
        return Object.entries(data).map(([part, condition]) => [
            part,
            condition.Intact ? "no" : "no",
            condition.Scratch ? "yes" : "",
            condition.Broken ? "yes" : "",
            condition.Dent ? "yes" : "",
        ]);
    };

    const [damagedParts, setDamagedParts] = useState([]);
    const fetchDamagePart = (data) => {
        const damagedParts = []; // Declare the damagedParts array

        // Process the data
        const formattedData = Object.entries(data).map(([part, condition]) => {
            // Check if any damage exists (Scratch, Broken, Dent)
            if (condition.Scratch || condition.Broken || condition.Dent) {
                // Store the part name if there's any damage
                damagedParts.push(part);
            }

        });
        setDamagedParts(damagedParts);
        // console.log("Damaged Parts:", damagedParts);
        return damagedParts;
    };
    const updateSvgAndConvertToDataUrl = async (damagedParts) => {
        // Fetch the SVG file
        const response = await fetch(`${process.env.PUBLIC_URL}/inspection-images/car_suv2.svg`);
        let svgText = await response.text();

        // Create a DOM parser to manipulate the SVG
        const parser = new DOMParser();
        const svgDocument = parser.parseFromString(svgText, "image/svg+xml");

        // Change fill color for damaged parts
        damagedParts.forEach((partId) => {
            const partElement = svgDocument.getElementById(partId);
            if (partElement) {
                partElement.style.fill = "red"; // Change fill color to red
            }
        });

        // Serialize the updated SVG back to a string
        const updatedSvgText = new XMLSerializer().serializeToString(svgDocument);

        // Create a Data URL from the updated SVG
        const dataUrl = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(updatedSvgText);
        return dataUrl;
    };

    const convertSvgToPng = async (svgDataUrl) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                const pngDataUrl = canvas.toDataURL('image/png');
                resolve(pngDataUrl);
            };
            img.onerror = (error) => {
                reject(error);
            };
            img.src = svgDataUrl; // Set the source to the SVG data URL
        });
    };


    const preloadImage = (src) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = src;
            img.onload = () => resolve(img);
            img.onerror = () => reject(new Error('Failed to load image'));
        });
    };

    const preloadIcons = async () => {
        try {
            const tickIcon = await preloadImage(`${process.env.PUBLIC_URL}/inspection-images/tick.png`);
            const damageIcon = await preloadImage(`${process.env.PUBLIC_URL}/inspection-images/damage-icon.png`);
            return { tickIcon, damageIcon };
        } catch (error) {
            console.error('Error loading icons:', error);
            throw error;
        }
    };


    // Function to add missing photo types using 'type'
    function addMissingPhotoTypesByType(result, configData) {
        const resultTypes = result.map(item => item.type);
        const missingTypes = configData.filter(config => !resultTypes.includes(config.type));
        // Checks for missing 'type'
        // console.log(result.length);

        if (result.length < 19) {
            // Add missing photo types based on 'type'
            result.push(...missingTypes.slice(0, 19 - result.length));
        }
    }
    const preloadLogo = (src) => {
        return new Promise((resolve, reject) => {
            const logo = new Image();
            logo.src = src;
            logo.onload = () => resolve(logo);
            logo.onerror = () => reject(new Error('Failed to load logo image'));
        });
    };//watermark logo


    const downloadPDF = async () => {
        if (targetRef.current) {
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4',
            });

            const scannedUrl = link_to_pdf(audit_id)
            drawPinkBorders(pdf)
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();

            let paddingLeft = 15;
            let paddingTop = 10;
            let paddingRight = 10;
            pdf.setLineWidth(0.5);



            try {
                // Add page for "Inspection Report" and tables(Page-1)
                // addHeaderToPDF(pdf, auditDetails);  //header
                await addHeaderToPDF(pdf, auditDetails, scannedUrl);


                const clickDate = auditDetails['Inspection Date'];
                const formattedClickedDate = clickDate;
                const formattedClickedTime = auditDetails['Inspection Time']

                let currentDateTime = result[0].annotation_timestamp ? result[0].annotation_timestamp : moment();
                currentDateTime = moment(currentDateTime, 'YYYY-MM-DD HH:mm:ss');
                const currentDate = currentDateTime.format('DD-MM-YYYY');
                const currentTime = currentDateTime.format('HH:mm:ss');
                const tableHeaders = [
                    [
                        { content: 'Name of Customer', colSpan: 1 }, { content: auditDetails['Name of Customer'].toUpperCase(), colSpan: 1 },
                        { content: 'Vehicle no', colSpan: 1 }, { content: auditDetails['Vehicle No'], colSpan: 1 }
                    ],
                    [
                        { content: 'User Id', colSpan: 1 }, { content: `${auditDetails['User Id']}     `, colSpan: 1 },
                        { content: 'Dealer code', colSpan: 1 }, { content: `${auditDetails['Dealer Code']}  `, colSpan: 1 }
                    ],
                    [
                        { content: 'Inspection date & time', colSpan: 1 }, { content: `${auditInfo.inspection_time}`, colSpan: 1 },
                        { content: 'Inspection Place', colSpan: 1 }, { content: `LATITUDE: ${parseFloat(result[0].latitude).toFixed(2)}, LONGITUDE: ${parseFloat(result[0].longitude).toFixed(2)} `, colSpan: 1 }
                        // { content: 'Inspection Time', colSpan: 1 }, { content: formattedClickedTime, colSpan: 1 }
                    ],
                    // [
                    //     { content: 'Inspection Place', colSpan: 1 }, { content: `LATITUDE: ${parseFloat(result[0].latitude).toFixed(2)}, LONGITUDE: ${parseFloat(result[0].longitude).toFixed(2)} `, colSpan: 3 }
                    // ],
                    [
                        { content: 'Recommendation', colSpan: 1, }, { content: recommendation, colSpan: 3 },
                    ]
                ];

                const x1 = 14; // X position
                const y1 = 34; // Y position
                const width1 = 180; // Width of the rectangle
                const height1 = 50; // Height of the rectangle
                const radius1 = 1.5; // Corner radius

                // Draw the filled rectangle with white background and shadow effect
                pdf.setDrawColor(0, 0, 0, 0.13); // Shadow effect
                pdf.setFillColor(255, 255, 255); // White background
                pdf.roundedRect(x1, y1, width1, height1, radius1, radius1, 'FD');

                // Draw the bottom border with a thicker line
                pdf.setLineWidth(0.8); // Thicker border for bottom
                pdf.line(x1, y1 + height1, x1 + width1, y1 + height1); // Bottom border

                // Draw the top, left, and right borders with a thinner line
                pdf.setLineWidth(0.005); // Thinner border for top, left, and right
                pdf.line(x1, y1, x1 + width1, y1); // Top border
                pdf.line(x1, y1, x1, y1 + height1); // Left border
                pdf.line(x1 + width1, y1, x1 + width1, y1 + height1); // Right border

                const fixedTableWidth = 180
                pdf.autoTable({
                    startY: 37.5,
                    head: [],
                    body: tableHeaders,
                    theme: 'plain',
                    styles: {
                        textColor: 'black',
                        fontSize: 9.2,
                        font: 'Mulish-SemiBold',
                        cellPadding: { top: 4, right: 0, bottom: 4, left: 3 },
                        lineWidth: 0
                    },
                    bodyStyles: {
                        halign: 'left',
                    },
                    tableWidth: fixedTableWidth, // Use the same fixed width as the first table
                    columnStyles: {
                        0: { cellWidth: 'auto' },
                        1: { cellWidth: 'auto', font: 'Mulish-Regular' },
                        2: { cellWidth: 'auto' },
                        3: { cellWidth: 'auto', font: 'Mulish-Regular' }
                    }
                });

                const subHeadingText3 = "Details of Vehicle";
                pdf.setFontSize(14);

                // jsPDF.API.events.push(['addFonts', callAddFont])
                pdf.setFont("Mulish-SemiBold", 'normal')
                pdf.text(subHeadingText3, paddingLeft, pdf.previousAutoTable.finalY + 10);

                const registrationDate = auditDetails['Registration Date'];
                const formattedRegistrationDate = registrationDate;
                const [lead_creation_date, lead_creation_time] = auditInfo.lead_creation_time.split(' ');
                console.log("696",auditDetails);

                const vehicleDetails = [
                    [{ content: 'Program Name', colSpan: 1 }, { content: auditDetails['Program Name'].toUpperCase(), colSpan: 1 }, { content: 'Client Unique Reference No.', colSpan: 1 }, { content: auditDetails['Client Unique Reference No.'], colSpan: 1 }],
                    [{ content: 'PI Type', colSpan: 1 }, { content: auditDetails['PI Type'].toUpperCase(), colSpan: 1, }, { content: 'Proposer Type', colSpan: 1 }, { content: auditDetails['Proposer Type'].toUpperCase(), colSpan: 1 }],
                    [{ content: 'Lead Created Date', colSpan: 1 }, { content: lead_creation_date, colSpan: 1 }, { content: 'Lead Created Time', colSpan: 1 }, { content: lead_creation_time, colSpan: 1 }],
                    [{ content: 'Insurance Company Name', colSpan: 1 }, { content: auditDetails['Insurance Company'].toUpperCase(), colSpan: 1 }, { content: 'Client Name', colSpan: 1 }, { content: auditDetails['Client Name'] ? auditDetails['Client Name'].toUpperCase() : '---', colSpan: 1 }],
                    [{ content: 'Vehicle Class', colSpan: 1 }, { content: auditDetails['Vehicle Class'].toUpperCase(), colSpan: 1 }, { content: 'Make', colSpan: 1 }, { content: auditDetails['Make'], colSpan: 1 }],
                    [{ content: 'Model Name', colSpan: 1 }, { content: auditDetails['Model'], colSpan: 1 }, { content: 'Variant Name', colSpan: 1 }, { content: auditDetails['Variant'], colSpan: 1 }],
                    [{ content: 'Body Type', colSpan: 1 }, { content: bodyType.toUpperCase(), colSpan: 1 }, { content: 'Chassis number', colSpan: 1 }, {
                        content: auditDetails['Chassis number'].toUpperCase(), colSpan: 1
                    }],
                    [{ content: 'Engine number', colSpan: 1 }, { content: auditDetails['Engine number'].toUpperCase(), colSpan: 1 }, { content: 'Year of Manufacturing', colSpan: 1 }, { content: auditDetails['Year of Manufacturing'], colSpan: 1 }],
                    [{ content: 'Registration Date', colSpan: 1 }, { content: formattedRegistrationDate, colSpan: 1 }, { content: 'Report Generate Date & Time', colSpan: 1 }, { content: `${currentDate} & ${currentTime}`, colSpan: 1 }]
                ];

                let tableHeight = 0;
                let startYY = 102;

                const x = 14; // X position
                const y = startYY; // Y position
                const width = 180; // Width of the rectangle
                const height = 94; // Height of the rectangle
                const radius = 1.5; // Corner radius

                // Draw the filled rectangle with white background and shadow effect
                pdf.setDrawColor(0, 0, 0, 0.13); // Shadow effect
                pdf.setFillColor(255, 255, 255); // White background
                pdf.roundedRect(x, y, width, height, radius, radius, 'FD');

                // Draw the bottom border with a thicker line
                pdf.setLineWidth(0.8); // Thicker border for bottom
                pdf.line(x, y + height, x + width, y + height); // Bottom border

                // Draw the top, left, and right borders with a thinner line
                pdf.setLineWidth(0.005); // Thinner border for top, left, and right
                pdf.line(x, y, x + width, y); // Top border
                pdf.line(x, y, x, y + height); // Left border
                pdf.line(x + width, y, x + width, y + height); // Right border

                pdf.autoTable({
                    startY: startYY + 2,
                    head: [],
                    body: vehicleDetails,
                    theme: 'plain',
                    styles: {
                        fontSize: 9.2,
                        font: 'Mulish-SemiBold',
                        cellPadding: { top: 3, right: 0, bottom: 2, left: 2 },
                        lineWidth: 0,
                        textColor: 'black'
                    },
                    bodyStyles: {
                        halign: 'left',
                    },
                    tableWidth: fixedTableWidth,
                    columnStyles: {
                        0: { cellWidth: 'auto' },
                        1: { cellWidth: 'auto', font: 'Mulish-Regular' },
                        2: { cellWidth: 'auto' },
                        3: { cellWidth: 'auto', font: 'Mulish-Regular' }
                    },
                    didDrawPage: function (data) {
                        tableHeight = data.cursor.y - startYY;
                    },
                    didDrawCell: function (data) {
                        if (data.cell.section === 'body') {
                            const cellHeight = data.cell.height;
                            tableHeight += cellHeight;
                        }
                    },
                    tableDidLoad: function (data) {
                        tableHeight = data.cursor.y - startYY;
                    }
                });
                //    console.log(tableHeight,"401");
                let addCounterY = 75;

                // if (tableHeight >= 73) {
                // 	let diff = tableHeight - 72;
                // 	addCounterY = diff * 1.7;
                // }

                pdf.setFontSize(13);
                pdf.setFont("Mulish-SemiBold", 'normal')
                const insuredDeclarationHead = "Digital Consent Declaration for Vehicle AI Inspection Report";
                pdf.text(insuredDeclarationHead, paddingLeft, 136 + addCounterY);

                pdf.setFontSize(10);
                pdf.setFont("Mulish-MediumItalic", 'normal')
                const insuredDeclaration = "Insured Declaration";
                pdf.text(insuredDeclaration, paddingLeft, 144 + addCounterY);

                pdf.setFontSize(9);
                pdf.setFont("Mulish-Regular", 'normal')
                const declarationParagraph = `By proceeding with the use of the provided link or application for self-inspection and generation of this AI-Assisted Report, I/We hereby confirm and declare that the identification of my vehicle mentioned above, as well as the damages observed by the inspection official, are accurate, with no information concealed or undisclosed.`;
                const paragraphLines = pdf.splitTextToSize(declarationParagraph, pageWidth - paddingLeft - paddingRight);
                pdf.text(paragraphLines, paddingLeft, 154 + addCounterY);

                pdf.setFontSize(9);
                pdf.setFont("Mulish-Regular", 'normal')
                const declarationParagraph2 = `Additionally, I affirm that the motor vehicle proposed for insurance, following a break-in cover, has not been involved in any accidents resulting in third-party claims for injury, death, or damages to any person, property, or the insured vehicle during the period following the expiry of the previous insurance until the moment it is proposed for insurance. I also acknowledge that the damages outlined in the report and recorded in the provided photographs will be excluded or adjusted in the event of any claim being lodged.`;
                const paragraphLines2 = pdf.splitTextToSize(declarationParagraph2, pageWidth - paddingLeft - paddingRight);
                pdf.text(paragraphLines2, paddingLeft, 170 + addCounterY);

                // Add the disclaimer paragraph
                pdf.addImage("/inspection-images/disclaimer.png", paddingLeft + 7, 198 + addCounterY, 5, 5)
                const disclaimerParagraph = `This document is generated by an AI-supported system. For the purpose of claim settlement, the assessment of damages based on photographs will be considered conclusive regarding the car's condition during the Pre-inspection, taking precedence over any damage recorded in the report.`;

                const disclaimerLines = pdf.splitTextToSize(disclaimerParagraph, pageWidth + 5);
                pdf.setFontSize(6);
                pdf.setFont("Mulish-Regular", "normal");
                pdf.text(disclaimerLines, paddingLeft + 15, 200 + addCounterY);

                // PAGE-2
                pdf.addPage();
                drawPinkBorders(pdf)
                addHeaderToPDF2(pdf, auditDetails);
                // await addHeaderToPDF(pdf, auditDetails, scannedUrl);

                // Add labels for "Dent" and "Scratch" below the heading


                // Draw the images
                const imageWidth = 50;
                const imageHeight = 60;
                const startX = 10;
                const startY = 10;
                const spacing = 5;
                const headingFontSize = 12;

                let latitude1 = parseFloat(result[0].latitude);
                let longitude1 = parseFloat(result[0].longitude);
                const image2Data = await loadImageData(`https://maps.geoapify.com/v1/staticmap?style=osm-bright&width=650&height=400&center=lonlat:${longitude1},${latitude1}&zoom=12.0&marker=lonlat:${longitude1},${latitude1};type:material;color:%23ff3421;icontype:awesome&apiKey=96d8bd6566b44537b0bf7baa4a914d50
					`); //map image
                // const image3Data = await loadImageData(imageUrls.images[16]);  //damage image
                const image3Data = `${process.env.PUBLIC_URL}/inspection-images/car_suv2.svg`
                // Calculate the aspect ratios of the images
                const aspectRatio2 = image2Data.width / image2Data.height;
                const aspectRatio3 = image3Data.width / image3Data.height;

                // Calculate the scaled image widths and heights while maintaining aspect ratio
                const scaledWidth2 = imageWidth;
                const scaledHeight2 = Number.isFinite(aspectRatio2) ? scaledWidth2 / aspectRatio2 : imageHeight;

                const scaledWidth3 = imageWidth + 70;
                const scaledHeight3 = Number.isFinite(aspectRatio3) ? scaledWidth3 / aspectRatio3 : imageHeight;

                // Add the damage image ()
                const startYThirdImage = 35;
                // pdf.rect(startXThirdImage + 15, startYThirdImage + 100, scaledWidth3 + 10, scaledHeight3 + 90);
                // pdf.addImage(image3Data, "JPEG", startX + 50 + spacing + 55, startYThirdImage + 115, scaledWidth3 - 30, scaledHeight3 + 30);   //damage image
                // console.log("714", scaledWidth3 - 30, scaledHeight3 + 30);

                //Adding table on page 2
                // const tableData = await fetchTableData();
                // const filteredData = tableData.filter(item =>
                // 	!/car|dent|scratch|broken/i.test(item[0])
                // );

                // const page2TableData = filteredData.slice(0, 25)
                // const page3TableData = filteredData.slice(25, 49)

                // const types = ["Intact", "Scratch", "Broken", "Dent"];
                // // const vehicleDetailsDataLeft = filteredData.map(item => [item[0], "", "", "", "", ""]);
                // const vehicleDetailsDataLeft = page2TableData.map(item => {
                // 	const result = ["", "", "", "", ""]; // Initialize with empty strings

                // 	if (item[1] >= 0 && item[1] < types.length) {
                // 		// result[item[1]] = types[item[1]]; // Set the type at the correct index + 1 (because index 0 is reserved)
                // 		result[0] = "---";
                // 	}
                // 	else {
                // 		result[0] = "---";
                // 	}
                // 	return [item[0].replace(/_/g, ' '), ...result]; // Include item[0] (name) followed by the result array
                // });
                // const vehicleDetailsFormattedLeft = [
                // 	[
                // 		{ content: '', colSpan: 1 },
                // 		{ content: 'Intact', colSpan: 1 },
                // 		{ content: 'Scratch', colSpan: 1 },
                // 		{ content: 'Broken', colSpan: 1 },
                // 		{ content: 'Dent', colSpan: 1 }
                // 	],
                // 	...vehicleDetailsDataLeft.map(row => row.map(cell => ({ content: cell, colSpan: 1 })))
                // ];
                const pos = 40;
                const middleMargin = 10;

                let x2 = 13; // X position
                let y2 = 40; // Y position
                let width2 = 120; // Width of the rectangle
                let height2 = 208; // Height of the rectangle
                let radius2 = 1.5; // Corner radius

                // Draw the filled rectangle with white background and shadow effect
                pdf.setDrawColor(0, 0, 0, 0.13); // Shadow effect
                pdf.setFillColor(255, 255, 255); // White background
                pdf.roundedRect(x2, y2, width2, height2, radius2, radius2, 'FD');

                // Draw the bottom border with a thicker line
                pdf.setLineWidth(0.8); // Thicker border for bottom
                pdf.line(x2, y2 + height2, x2 + width2, y2 + height2); // Bottom border

                // Draw the top, left, and right borders with a thinner line
                pdf.setLineWidth(0.005); // Thinner border for top, left, and right
                pdf.line(x2, y2, x2 + width2, y2); // Top border
                pdf.line(x2, y2, x2, y2 + height2); // Left border
                pdf.line(x2 + width2, y2, x2 + width2, y2 + height2); // Right border

                //new part details
                const partDetailsDataAll = await fetchPartDetails(audit_id)
                // console.log("843", partDetailsDataAll.partDetails);

                const partDetailsData = partDetailsDataAll.partDetails

                // Step 1: Convert the object to an array of entries
                const entries = Object.entries(partDetailsData);
                // console.log("802", entries, entries.length);//49

                // Step 2: Determine the split point (halfway in this case)
                const splitIndex = Math.ceil(entries.length / 2);
                // console.log("806", splitIndex);//25

                // Step 3: Split the entries into two parts
                const firstHalfEntries = entries.slice(0, splitIndex);
                const secondHalfEntries = entries.slice(splitIndex);
                // console.log(firstHalfEntries, secondHalfEntries);

                // Step 4: Convert the split arrays back into objects
                const firstHalfData = Object.fromEntries(firstHalfEntries);
                const secondHalfData = Object.fromEntries(secondHalfEntries);
                // console.log(firstHalfData, secondHalfData);

                const partDetailsTableData = formatVehicleDetails(firstHalfData);
                const { tickIcon, damageIcon } = await preloadIcons();
                // updateRecommendation(partDetailsTableData);
                pdf.autoTable({
                    startY: pos,
                    head: [[" ", "Intact", "Scratch", "Broken", "Dent"]],
                    body: partDetailsTableData,
                    theme: "plain",
                    styles: {
                        textColor: "black",
                        fillColor: "#FFF",
                        fontSize: 9,
                        font: "Mulish-SemiBold",
                        cellPadding: { top: 2.5, right: 3, bottom: 2.5, left: 4 },
                        lineWidth: 0,
                    },
                    bodyStyles: {
                        halign: 'left',
                    },
                    margin: {
                        left: paddingLeft,
                        right: (pageWidth / 2) - middleMargin,
                    },
                    tableWidth: 'wrap',
                    columnStyles: {
                        0: { cellWidth: 'auto' },
                        2: { cellWidth: 'auto' },
                        4: { cellWidth: 'auto' },
                        1: { cellWidth: 'auto', fillColor: '#F0F0F0' },
                        3: { cellWidth: 'auto', fillColor: '#F0F0F0' },
                    },
                    didParseCell: (data) => {
                        const { cell } = data;

                        // Clear the text for 'yes' or 'no'
                        if (typeof cell.raw === 'string' && (cell.raw === 'yes' || cell.raw === 'no')) {
                            cell.text = '';
                        }
                    },
                    didDrawCell: (data) => {
                        const { cell, row, column } = data;
                        const { doc } = data;

                        // Check if we are in the "Intact" column (column index 1)
                        if (column.index === 1 && typeof cell.raw === 'string' && cell.raw === 'no') {
                            // Check the corresponding row for "Scratch", "Broken", and "Dent" columns
                            const intact = row.cells[1].raw
                            const scratch = row.cells[2].raw;
                            const broken = row.cells[3].raw;
                            const dent = row.cells[4].raw;

                            // Only draw tick icon if "Scratch", "Broken", and "Dent" columns are empty
                            if (!scratch && !broken && !dent) {
                                const { x, y, height } = cell;
                                pdf.addImage(tickIcon, 'PNG', x + 5, y + 1, 8, height - 2); // Adjust size as needed
                            }
                        } else if (typeof cell.raw === 'string' && cell.raw === 'yes') {
                            const { x, y, height } = cell;
                            pdf.addImage(damageIcon, 'PNG', x + 5, y + 1, 6, height - 4); // Adjust size as needed
                        }
                    }
                });

                //PAGE-3(part details page)
                pdf.addPage();
                drawPinkBorders(pdf)
                addHeaderToPDF2(pdf, auditDetails);
                // await addHeaderToPDF(pdf, auditDetails, scannedUrl);

                //1.360 image 
                const classColorMap = {
                    "1": "#3ea145", // Color for class 1 (dent)
                    "2": "#FF5733",

                };
                const classLabelMap = {
                    "1": "Captured",
                    "2": "Not Captured",

                };

                let legendX = paddingLeft;
                let legendY = 15;
                const legendBoxSize = 1.5;
                const legendSpacing = 3;
                const labelSpacing = 20;

                Object.keys(classLabelMap).forEach((classId) => {
                    const label = classLabelMap[classId];
                    const color = classColorMap[classId];

                    pdf.setFillColor(color);
                    pdf.setFontSize(10);
                    pdf.setFont("Mulish-Regular", "normal");
                    pdf.circle(legendX + 120, legendY + 121, legendBoxSize, 'F'); // Draw filled rectangle
                    pdf.setTextColor("#000000");
                    pdf.text(
                        label,
                        legendX + legendBoxSize + legendSpacing + 120,
                        legendY + legendBoxSize + 121
                    );
                    legendX += legendBoxSize + legendSpacing + labelSpacing;
                });
                //...

                const startXMainHeading = 10;
                const startYMainHeading = 10;
                const mainHeadingFontSize = 15;
                pdf.setFontSize(mainHeadingFontSize);

                // console.log(bodyType);
                // Define the mapping of bodytypes to image indices
                const bodyTypeToImageIndex = {
                    "Station wagon": 14,
                    "Muv": 13,
                    "COUPE": 12,
                    "Saloon": 11,
                    "Sedan": 10,
                    "Hatch Back": 9,
                    "Convertible": 8,
                    "Suv": 7,
                    "sportscar": 6,
                    "hatchback 3 door": 5,
                    "minivan": 4,
                    "---": 9
                };

                // bodyType="Suv";
                // Get the image index based on the bodytype
                const imageIndex = bodyTypeToImageIndex[bodyType] || 9;

                // Load the image dynamically based on the bodytype
                const carImage = await loadImageData(imageUrls.images[imageIndex]);

                // const carImage = await loadImageData(imageUrls.images[4]);
                const carImageElement = new Image();
                carImageElement.src = carImage;
                await new Promise(resolve => {
                    carImageElement.onload = resolve;
                });
                const carImageDataUrl = carImageElement.src;
                const carImageWidth = 31;
                const carImageHeight = 72;
                const imageX = 153;  // X-coordinate where the car image is placed
                const imageY = 50;   // Y-coordinate where the car image is placed

                pdf.addImage(carImageDataUrl, "JPEG", imageX, imageY, carImageWidth, carImageHeight);

                //DRAW CIRCLES
                const positions = {
                    front_side: { top: -12, left: 50 },        // Above top center
                    front_left_side: { top: 4, left: -15 },     // Top-left (spaced out further)
                    left_side: { top: 40, left: -30 },         // Left center (spaced out further)
                    back_left_side: { top: 82, left: -15 },     // Bottom-left (spaced out further)
                    back_side: { top: 110, left: 52 },         // Below bottom center
                    back_right_side: { top: 80, left: 112 },   // Bottom-right (spaced out further)
                    right_side: { top: 40, left: 130 },        // Right center (spaced out further)
                    front_right_side: { top: 2, left: 112 }    // Top-right (spaced out further)
                };


                data.forEach((item, index) => {
                    const position = positions[item.name];
                    if (position) {
                        const circleX = (carImageWidth * position.left / 100) + imageX;
                        const circleY = (carImageHeight * position.top / 100) + imageY;
                        // console.log(circleX, circleY);

                        // Use fill color and draw circle
                        pdf.setFillColor("green");
                        pdf.circle(circleX, circleY, 2.7, 'F');
                    }
                });

                //2.damage image-(for part details)

                const classColorMap1 = {
                    "1": "#F10000", // Color for class 1 (dent)
                    "2": "#E57E04",
                    "3": "#F5B942",

                };
                const classLabelMap1 = {
                    "1": "Severe",
                    "2": "Moderate",
                    "3": "low",

                };

                let legendX1 = paddingLeft;
                let legendY1 = 15;
                const legendBoxSize1 = 1.5;
                const legendSpacing1 = 3;
                const labelSpacing1 = 20;

                Object.keys(classLabelMap1).forEach((classId) => {
                    const label1 = classLabelMap1[classId];
                    const color1 = classColorMap1[classId];

                    pdf.setFillColor(color1);
                    pdf.setFontSize(10);
                    pdf.setFont("Mulish-Regular", "normal");
                    pdf.circle(legendX1 + 120, legendY1 + 215, legendBoxSize1, 'F'); // Draw filled rectangle
                    pdf.setTextColor("#000000");
                    pdf.text(
                        label1,
                        legendX1 + legendBoxSize1 + legendSpacing1 + 120,
                        legendY1 + legendBoxSize1 + 215
                    );
                    legendX1 += legendBoxSize1 + legendSpacing1 + labelSpacing1;
                });
                const damagedParts = fetchDamagePart(partDetailsData)
                console.log("1192", damagedParts);
                const svgDataUrl = await updateSvgAndConvertToDataUrl(damagedParts);
                const pngDataUrl = await convertSvgToPng(svgDataUrl);
                pdf.addImage(pngDataUrl, "JPEG", startX + 125 + spacing, startYThirdImage + 95, scaledWidth3 - 50, scaledHeight3 + 40);

                //3.map image
                pdf.setFontSize(10);
                pdf.setFont("Mulish-Regular", "normal");
                pdf.text("Inspection Location-", startX + spacing + 119, startY + 220 + scaledHeight2);
                pdf.addImage(image2Data, "JPEG", startX + 115 + spacing, startY + 225, scaledWidth2 + 20, scaledHeight2 - 10);  //map image

                const formattedLatitude = latitude1.toFixed(2)
                const formattedLongitude = longitude1.toFixed(2)
                // console.log(formattedLongitude, formattedLatitude);
                let location = await getLocation(latitude1, longitude1);
                // console.log("998", location);
                const inspectionCity = location && location.county || location.city || location.town
                    ? ` ${location.county || location.city || location.town}`
                    : `Coordinates: (${formattedLatitude}N ${formattedLongitude}E)`;
                // console.log(inspectionCity);
                pdf.setFontSize(9);
                pdf.setFont("Mulish-Regular", "normal");
                pdf.text(inspectionCity, startX + spacing + 152, startY + 220 + scaledHeight2);

                let x3 = 14; // X position
                let y3 = 40; // Y position
                let width3 = 113; // Width of the rectangle
                let height3 = 208; // Height of the rectangle
                let radius3 = 1.5; // Corner radius

                // Draw the filled rectangle with white background and shadow effect
                pdf.setDrawColor(0, 0, 0, 0.13); // Shadow effect
                pdf.setFillColor(255, 255, 255); // White background
                pdf.roundedRect(x3, y3, width3, height3, radius3, radius3, 'FD');

                // Draw the bottom border with a thicker line
                pdf.setLineWidth(0.8); // Thicker border for bottom
                pdf.line(x3, y3 + height3, x3 + width3, y3 + height3); // Bottom border

                // Draw the top, left, and right borders with a thinner line
                pdf.setLineWidth(0.005); // Thinner border for top, left, and right
                pdf.line(x3, y3, x3 + width3, y3); // Top border
                pdf.line(x3, y3, x3, y3 + height3); // Left border
                pdf.line(x3 + width3, y3, x3 + width3, y3 + height3); // Right border


                const pos1 = 40;
                const partDetailsTableDataPage3 = formatVehicleDetails(secondHalfData);

                pdf.autoTable({
                    startY: pos1,
                    head: [[" ", "Intact", "Scratch", "Broken", "Dent"]],
                    body: partDetailsTableDataPage3,
                    theme: "plain",
                    styles: {
                        textColor: "black",
                        fillColor: "#FFF",
                        fontSize: 9,
                        font: "Mulish-SemiBold",
                        cellPadding: { top: 2.5, right: 3, bottom: 2.5, left: 4 },
                        lineWidth: 0,
                    },
                    bodyStyles: {
                        halign: 'left',
                    },
                    margin: {
                        left: paddingLeft,
                        right: (pageWidth / 2) - middleMargin,
                    },
                    tableWidth: 'wrap',
                    columnStyles: {
                        0: { cellWidth: 'auto' },
                        2: { cellWidth: 'auto' },
                        4: { cellWidth: 'auto' },
                        1: { cellWidth: 'auto', fillColor: '#F0F0F0' },
                        3: { cellWidth: 'auto', fillColor: '#F0F0F0' },
                    },
                    didParseCell: (data) => {
                        const { cell } = data;

                        // Clear the text for 'yes' or 'no'
                        if (typeof cell.raw === 'string' && (cell.raw === 'yes' || cell.raw === 'no')) {
                            cell.text = ''; // Clear the text
                        }
                    },
                    didDrawCell: (data) => {
                        const { cell, row, column } = data;
                        const { doc } = data;

                        // Check if we are in the "Intact" column (column index 1)
                        if (column.index === 1 && typeof cell.raw === 'string' && cell.raw === 'no') {
                            // Check the corresponding row for "Scratch", "Broken", and "Dent" columns
                            const intact = row.cells[1].raw
                            const scratch = row.cells[2].raw;
                            const broken = row.cells[3].raw;
                            const dent = row.cells[4].raw;

                            // Only draw tick icon if "Scratch", "Broken", and "Dent" columns are empty
                            if (!scratch && !broken && !dent) {
                                const { x, y, height } = cell;
                                pdf.addImage(tickIcon, 'PNG', x + 5, y + 1, 8, height - 2); // Adjust size as needed
                            }
                        } else if (typeof cell.raw === 'string' && cell.raw === 'yes') {
                            const { x, y, height } = cell;
                            pdf.addImage(damageIcon, 'PNG', x + 5, y + 1, 6, height - 4); // Adjust size as needed
                        }
                    }
                });

                //Page-4 onwards Add page for audit details(inspection photos)
                pdf.addPage();
                let isFirstPage = true;
                let currentY = 15;
                let resultsPerPage = 2;
                // console.log(result.length, result, typeof (result));
                if (result.length < 19) {
                    // Add missing photo types based on 'type'
                    addMissingPhotoTypesByType(result, data);
                }
                // console.log(result.length, result, typeof (result));

                for (let i = 0; i < result.length; i += resultsPerPage) {
                    const itemsToRender = result.slice(i, i + resultsPerPage);
                    if (!isFirstPage) {
                        pdf.addPage();
                        currentY = 15;
                        // Add page border
                        const pagesAdded = pdf.internal.getNumberOfPages();
                        for (let i = 0; i < pagesAdded; i++) {
                            pdf.setPage(i + 1);
                            pdf.setDrawColor(0);
                        }
                        drawPinkBorders(pdf)
                        addHeaderToPDF2(pdf, auditDetails);
                        // await addHeaderToPDF(pdf, auditDetails, scannedUrl);

                    } else {

                        drawPinkBorders(pdf)
                        addHeaderToPDF2(pdf, auditDetails);
                        // await addHeaderToPDF(pdf, auditDetails, scannedUrl);

                        isFirstPage = false;
                        pdf.setFontSize(12);
                        pdf.setFont("helvetica", "bold");
                        pdf.setTextColor(0, 0, 0);
                        const textWidth =
                            (pdf.getStringUnitWidth("Inspection Photos") *
                                pdf.internal.getFontSize()) / pdf.internal.scaleFactor;
                        const textX = (pageWidth - textWidth) / 2;
                        // pdf.text("Inspection Photos", textX, currentY);
                        currentY += 10; // Adjusted paddingTop

                        // Add labels for "Dent" and "Scratch" below the heading
                        const classColorMap = {
                            "1": "#39FF14", // Color for class 1 (dent)
                            "2": "#FF5733",
                            "3": "#16F5BD",
                            "4": "#34c0eb", // Color for class 2 (scratch)
                        };
                        const classLabelMap = {
                            "1": "Dent",
                            "2": "Scratch",
                            "3": "Broken",
                            "4": "Windshield(Damage)",

                        };

                        let legendX = paddingLeft;
                        let legendY = currentY + 10;
                        const legendBoxSize = 1.2;
                        const legendSpacing = 2;
                        const labelSpacing = 20;

                        Object.keys(classLabelMap).forEach((classId) => {
                            const label = classLabelMap[classId];
                            const color = classColorMap[classId];

                            pdf.setFillColor(color);
                            pdf.circle(legendX, legendY + 5, legendBoxSize, 'F'); // Draw filled rectangle
                            pdf.setTextColor("#000000");
                            pdf.setFontSize(8)
                            pdf.setFont("Mulish-Regular", 'normal')
                            pdf.text(
                                label,
                                legendX + legendBoxSize + legendSpacing + 1,
                                legendY + legendBoxSize + 5
                            );
                            legendX += legendBoxSize + legendSpacing + labelSpacing;
                        });
                        pdf.setFont("Mulish-SemiBold", 'normal')
                        pdf.setFontSize(9)
                        // pdf.text(
                        //     "0-No Fraud    1-Vehicle swap   2-Location swap   3-Temporary repair    4-Photo of photo",
                        //     15,
                        //     legendY + legendBoxSize + 12
                        // );
                        currentY += legendBoxSize;

                    }

                    for (const item of itemsToRender) {
                        // Reset padding for audit details page
                        let paddingLeft = 10;
                        let paddingTop = currentY + 20; // Adjusted paddingTop
                        let paddingRight = 15;

                        console.log("downloading")
                        const type = item.type;
                        // console.log(type);
                        // console.log(data)
                        const title_name = data.filter((d) => d.id.toString() === type.toString()).map((m) => m.name)[0];

                        const title = title_name.toUpperCase().split("_").join(" ");
                        const momentClickedTime = moment(item.clicked_time);
                        // const formattedTime = momentClickedTime.format('MMM DD, YYYY h:mm A');
                        const formattedTime = momentClickedTime.isValid()
                            ? momentClickedTime.format('MMM DD, YYYY h:mm A')
                            : '---';

                        // const audit_id = audit_id;
                        const latitude = parseFloat(item.latitude);
                        const longitude = parseFloat(item.longitude);
                        const formattedLatitude = latitude.toFixed(2)
                        const formattedLongitude = longitude.toFixed(2)
                        let location = await getLocation(latitude, longitude);

                        // Check if location is null (indicating fetch error or no data found)
                        if (!location) {
                            location = {
                                county: '',
                                state: '',
                            };
                        }

                        //---->
                        const locationForTable = location && location.state_district || location.county || location.city || location.town
                            ? `${location.state_district || location.county || location.city || location.town} District, ${location.state}, IN (${formattedLatitude}N ${formattedLongitude}E)`
                            : `---`;
                        //watermarks for images(city,district,state)
                        const locationForTable0 = location && location.county || location.city || location.town
                            ? ` ${location.county || location.city || location.town}`
                            : `Coordinates: (${formattedLatitude}N ${formattedLongitude}E)`;

                        const locationForTable1 = location && location.state_district || location.county || location.city
                            ? `${location.state_district || location.county || location.city} District`
                            : `Coordinates: (${formattedLatitude}N ${formattedLongitude}E)`;

                        const locationForTable2 = location && location.state
                            ? ` ${location.state}, IN`
                            : `Coordinates: (${formattedLatitude}N ${formattedLongitude}E)`;

                        // console.log(locationForTable, locationForTable0, locationForTable1, locationForTable2);
                        const additionalDetails = [
                            [
                                { content: 'Photo Type', colSpan: 1 }, { content: title, colSpan: 1 },
                                { content: 'Date', colSpan: 1 }, { content: formattedTime, colSpan: 1 }
                            ],
                            [
                                { content: 'Audit ID', colSpan: 1 }, { content: audit_id, colSpan: 1 },
                                { content: 'Location', colSpan: 1 },
                                {
                                    content: locationForTable, colSpan: 1
                                }
                            ]
                        ];
                        // console.log("1339", auditDetails);

                        const chassisNumberStatus = partDetailsDataAll.chassisNo?.toLowerCase() === auditDetails['Chassis number']?.toLowerCase() 
                        ? ' (Match)' 
                        : ' (Mismatch)';
                        // Conditionally add rows based on item.type
                        if (item.type === "11") {
                            additionalDetails.push([
                                { content: 'Odometer Number', colSpan: 1 }, { content: partDetailsDataAll.odometer || 'Odometer number not detected', colSpan: 3 }
                            ]);
                        } else if (item.type === "1" || item.type === "5") {
                            additionalDetails.push([
                                { content: 'License Plate Number', colSpan: 1 }, { content: partDetailsDataAll.LicenseNo || 'License Plate not detected', colSpan: 3 }
                            ]);
                        } else if (item.type === "14") {
                            additionalDetails.push([
                                { content: 'RC Number', colSpan: 1 }, { content: partDetailsDataAll.rc || 'RC Number not detected', colSpan: 3 }
                            ]);
                        } else if (item.type === "13") {
                            // additionalDetails.push([
                            //     { content: 'Chassis Number', colSpan: 1 }, { content: partDetailsDataAll.chassisNo || 'Chassis Number not detected', colSpan: 3 }
                            // ]);
                            additionalDetails.push([
                                { content: 'Chassis Number', colSpan: 1 },
                                { content: partDetailsDataAll.chassisNo ? `${partDetailsDataAll.chassisNo}${chassisNumberStatus}` : 'Chassis Number not detected', colSpan: 3 }
                            ]);
                        } else if (item.type === "12") {
                            additionalDetails.push([
                                { content: 'Registration Number', colSpan: 1 }, { content: item.result[0]?.number || auditDetails['Vehicle No'], colSpan: 3 }
                            ]);
                        } else if (item.type === "15") {
                            additionalDetails.push([
                                { content: 'Tyre Number', colSpan: 1 }, { content: partDetailsDataAll.frontLeftTyreNo || 'Tyre Number not detected', colSpan: 3 }
                            ]);
                        }
                        else if (item.type === "16") {
                            additionalDetails.push([
                                { content: 'Tyre Number', colSpan: 1 }, { content: partDetailsDataAll.backLeftTyreNo || 'Tyre Number not detected', colSpan: 3 }
                            ]);
                        }
                        else if (item.type === "17") {
                            additionalDetails.push([
                                { content: 'Tyre Number', colSpan: 1 }, { content: partDetailsDataAll.backRightTyreNo || 'Tyre Number not detected', colSpan: 3 }
                            ]);
                        }
                        else if (item.type === "18") {
                            additionalDetails.push([
                                { content: 'Tyre Number', colSpan: 1 }, { content: partDetailsDataAll.frontRightTyreNo || 'Tyre Number not detected', colSpan: 3 }
                            ]);
                        }



                        addAdditionalDetails(pdf, additionalDetails, paddingLeft, paddingTop - 5);
                        const tableHeight = additionalDetails.length;
                        const originalText = "Original Image";
                        // let aiText = item.result.map(resultItem => {
                        // 	let damageStatus = 'AI Processed Image';

                        // 	// Check for specific classes

                        // 	if (resultItem.class === 'bb79' || resultItem.class === '8abc') {
                        // 		damageStatus = 'AI Processed Image - Damaged Detected';
                        // 		return damageStatus;
                        // 	}
                        // 	// Check windshield coordinates
                        // 	if (resultItem.class === 'windshield' && (resultItem.x !== 0 || resultItem.y !== 0 || resultItem.width !== 0 || resultItem.height !== 0)) {
                        // 		damageStatus = 'AI Processed Image - Damaged Detected';
                        // 		return damageStatus;
                        // 	}
                        // 	return 0;
                        // 	console.log(damageStatus,"990")

                        // });

                        // // const aiText = "AI Processed Image - Damaged Detected ";
                        // aiText= aiText.filter((text)=>text !== 0);
                        // console.log(aiText,"9999")
                        // const ai_modified_text=aiText.length > 0 ? aiText[0]:'AI Processed Image';
                        // console.log(ai_modified_text,typeof ai_modified_text,"999")
                        const subHeadingX1 = paddingLeft;
                        const subHeadingX2 = 110
                        const subHeadingY = paddingTop + 40;
                        const subHeadingFontSize = 12;
                        let newVerticalPos;
                        if (tableHeight === 3) {
                            newVerticalPos = paddingTop + 38
                        } else {
                            newVerticalPos = paddingTop + 37
                        }
                        pdf.setFontSize(subHeadingFontSize);
                        pdf.setFont("Mulish-SemiBold", 'normal')
                        pdf.text(originalText, subHeadingX1, newVerticalPos);
                        // Check if the title matches REGISTRATIONNO, CHASSIS, RC, or ODOMETER
                        if (!['REGISTRATIONNO', 'REGISTRATION PLATE', 'CHASSIS', 'RC', 'ODOMETER', 'FRONT LEFT TYRE', 'FRONT RIGHT TYRE', 'BACK RIGHT TYRE', 'BACK LEFT TYRE', "SELFIE"].includes(title)) {
                            pdf.text("AI Processed Image", subHeadingX2, newVerticalPos);
                        }
                        currentY += 10;

                        if (item) {
                            // console.log(item);

                            const canvas1 = document.createElement("canvas");
                            const ctx1 = canvas1.getContext("2d");

                            const canvas2 = document.createElement("canvas");
                            const ctx2 = canvas2.getContext("2d");

                            const imageElement1 = new Image();
                            imageElement1.crossOrigin = "anonymous";
                            imageElement1.src = item.imageURL//get_image_url(item.image_name);
                            // imageElement1.src = get_image_url(item.image_name);
                            const imageElement2 = new Image();
                            imageElement2.crossOrigin = "anonymous";
                            imageElement2.src = item.imageURL//get_image_url(item.image_name);

                            // let aiURL;
                            // if(item.imageURL.length)
                            // 	{
                            // 		aiURL = item.imageURL
                            // 	// console.log(aiURL," item.imageURL")
                            // }else{
                            // 	console.log("normalURL")
                            // 	aiURL = get_image_url(item.image_name);
                            // }
                            // console.log(item.imageURL);




                            const classColorMap = {
                                "bb79": "#39FF14", //  (dent)
                                "8abc": "#FF5733",  // (scratch)
                                "windshield": "#34c0eb",  //(windshield) 
                                "09q2": "#16F5BD", // Color for class 2 (scratch)

                            }
                            await Promise.all([
                                new Promise((resolve) => {
                                    imageElement1.onload = async () => {
                                        const [compressed] = await processImages(imageElement1);

                                        const { img: compressedImg } = compressed;
                                        const imageWidth = compressedImg.width;
                                        const imageHeight = compressedImg.height;
                                        canvas1.width = imageWidth;
                                        canvas1.height = imageHeight;
                                        ctx1.drawImage(compressedImg, 0, 0, imageWidth, imageHeight);
                                        resolve();
                                    };
                                }),
                                new Promise((resolve) => {
                                    imageElement2.onload = async () => {
                                        const [compressed] = await processImages(imageElement2);
                                        const { img: compressedImg, scaleX: scaleX2, scaleY: scaleY2 } = compressed;
                                        const imageWidth = compressedImg.width;
                                        const imageHeight = compressedImg.height;
                                        canvas2.width = imageWidth;
                                        canvas2.height = imageHeight;
                                        ctx2.drawImage(compressedImg, 0, 0, imageWidth, imageHeight);

                                        item.result.forEach((box) => {
                                            // Check if the class exists in the classColorMap
                                            const color = classColorMap[box.class];
                                            if (color) {
                                                ctx2.globalAlpha = 0.6;
                                                ctx2.lineWidth = 5;
                                                ctx2.fillStyle = color;
                                                ctx2.strokeStyle = color;
                                                ctx2.strokeRect(
                                                    box.x * scaleX2,
                                                    box.y * scaleY2,
                                                    box.width * scaleX2,
                                                    box.height * scaleY2
                                                );
                                            }
                                        });
                                        resolve();
                                    };
                                }),

                                // new Promise((resolve) => {
                                // 	imageElement1.onload = () => {
                                // 		const imageWidth = imageElement1.width;
                                // 		const imageHeight = imageElement1.height;
                                // 		canvas1.width = imageWidth;
                                // 		canvas1.height = imageHeight;
                                // 		ctx1.drawImage(
                                // 			imageElement1,
                                // 			0,
                                // 			0,
                                // 			imageWidth,
                                // 			imageHeight
                                // 		);
                                // 		resolve();
                                // 	};
                                // }),
                                // new Promise((resolve) => {
                                // 	imageElement2.onload = () => {
                                // 		const imageWidth = imageElement2.width;
                                // 		const imageHeight = imageElement2.height;
                                // 		canvas2.width = imageWidth;
                                // 		canvas2.height = imageHeight;
                                // 		ctx2.drawImage(
                                // 			imageElement2,
                                // 			0,
                                // 			0,
                                // 			imageWidth,
                                // 			imageHeight
                                // 		);
                                // 		resolve();
                                // 	};
                                // }),

                            ]);

                            // const tableHeight = additionalDetails.length;
                            const availableWidth = pageWidth - paddingLeft - paddingRight;
                            const availableHeight = pageHeight - (currentY + tableHeight);

                            let imgWidth1 = canvas1.width,
                                imgHeight1 = canvas1.height;

                            let imgWidth2 = canvas2.width,
                                imgHeight2 = canvas2.height;

                            const aspectRatio1 = imgWidth1 / imgHeight1;
                            const aspectRatio2 = imgWidth2 / imgHeight2;

                            // Calculate the desired width for each image (half of the available width)
                            const desiredWidth = availableWidth / 2;
                            // Calculate the adjusted heights while maintaining aspect ratio
                            const adjustedHeight1 = desiredWidth / aspectRatio1;
                            const adjustedHeight2 = desiredWidth / aspectRatio2;
                            // Adjust the width and height based on available space
                            if (adjustedHeight1 > availableHeight || adjustedHeight2 > availableHeight) {
                                // If the adjusted height exceeds the available height, scale down both images
                                const scaleFactor = Math.min(availableHeight / adjustedHeight1, availableHeight / adjustedHeight2);
                                // console.log(scaleFactor, "1079")
                                imgWidth1 = desiredWidth * scaleFactor;
                                imgHeight1 = (adjustedHeight1 * scaleFactor) + 10;
                                imgWidth2 = desiredWidth * scaleFactor;
                                imgHeight2 = (adjustedHeight2 * scaleFactor) + 10;

                            } else {
                                // Otherwise, use the desired width and adjusted heights directly
                                imgWidth1 = desiredWidth
                                imgHeight1 = adjustedHeight1;
                                imgWidth2 = desiredWidth;
                                imgHeight2 = adjustedHeight1;
                                // console.log(imgWidth1, imgHeight1, imgWidth2, imgHeight2, "1091")
                            }

                            // Function to add watermark text and logo to the canvas
                            // function addWatermark(canvas, watermarkText1, watermarkText0, watermarkText2, watermarkText3, logoSrc) {
                            // 	return new Promise((resolve, reject) => {
                            // 		const context = canvas.getContext('2d');
                            // 		const logo = new Image();

                            // 		context.font = '40px Mulish-Regular';
                            // 		context.fillStyle = 'rgba(255, 255, 255, 1)';
                            // 		context.textAlign = 'right';
                            // 		context.textBaseline = 'bottom';

                            // 		// Position watermark text in the bottom right corner
                            // 		const textX = canvas.width - 20; // Slightly inset from the right edge
                            // 		const textY = canvas.height / 2 + 230; // Slightly inset from the bottom edge
                            // 		context.fillText(watermarkText1, textX, textY);
                            // 		context.fillText(watermarkText0, textX, textY + 50);
                            // 		context.fillText(watermarkText2, textX, textY + 100);
                            // 		context.fillText(watermarkText3, textX, textY + 150);

                            // 		logo.src = logoSrc;
                            // 		logo.onload = () => {
                            // 			const logoWidth = canvas.width * 0.2;
                            // 			const logoHeight = logo.height / logo.width * logoWidth;
                            // 			const logoX = canvas.width - logoWidth - 20; // Position near the top-right corner
                            // 			const logoY = 15;
                            // 			const borderRadius = 70; // Adjust the radius for rounded corners
                            // 			context.fillStyle = 'rgba(25, 25, 25, 0.6)';
                            // 			context.beginPath();
                            // 			context.roundRect(logoX - 10, logoY - 10, logoWidth + 20, logoHeight + 5, borderRadius);
                            // 			context.fill();

                            // 			context.drawImage(logo, logoX, logoY, logoWidth, logoHeight);
                            // 			resolve(canvas.toDataURL("image/jpeg", 0.95));
                            // 		};
                            // 		logo.onerror = () => reject(new Error('Failed to load logo image'));
                            // 	});
                            // }
                            // Define the logo path
                            // const watermarkLogo = `${process.env.PUBLIC_URL}/inspection-images/watermark-logo.png`;

                            // const writeFraudCode = (canvas, fraudCodes) => {
                            //     const context = canvas.getContext('2d');

                            //     // Set text properties for fraud code
                            //     context.font = '30px Mulish-Regular';
                            //     context.textAlign = 'left';
                            //     context.textBaseline = 'top';

                            //     const startX = 20; // X position for the text
                            //     const startY = 20; // Starting Y position for the text
                            //     const lineHeight = 40; // Space between lines for multiple fraud codes

                            //     // Define colors for text fill and stroke
                            //     const fillColor = 'beige'; // Fill color for the text
                            //     const strokeColor = 'gold'; // Border color for the text
                            //     const lineWidth = 2; // Stroke width

                            //     // Function to draw text with a border
                            //     const drawTextWithBorder = (text, x, y) => {
                            //         // Set stroke style and draw the stroke
                            //         context.strokeStyle = strokeColor;
                            //         context.lineWidth = lineWidth;
                            //         context.strokeText(text, x, y);

                            //         // Set fill style and draw the filled text
                            //         context.fillStyle = fillColor;
                            //         context.fillText(text, x, y);
                            //     };

                            //     // Loop through the array of fraud codes and write each one with a border
                            //     fraudCodes.forEach((fraudCode, index) => {
                            //         const yPosition = startY + (index * lineHeight); // Calculate Y position for each fraud code
                            //         drawTextWithBorder(`Fraud Code: ${fraudCode}`, startX, yPosition);
                            //     });
                            // };
                            const writeFraudCode = (canvas, fraudCodes) => {
                                const context = canvas.getContext('2d');

                                // Set text properties for fraud code
                                context.font = '30px Mulish-Regular';
                                context.textAlign = 'left';
                                context.textBaseline = 'top';

                                const startX = 20;
                                const startY = 20;

                                // Define colors for text fill and stroke
                                const fillColor = 'beige';
                                const strokeColor = 'gold';
                                const lineWidth = 2;

                                // Function to draw text with a border
                                const drawTextWithBorder = (text, x, y) => {
                                    // Set stroke style and draw the stroke
                                    context.strokeStyle = strokeColor;
                                    context.lineWidth = lineWidth;
                                    context.strokeText(text, x, y);

                                    // Set fill style and draw the filled text
                                    context.fillStyle = fillColor;
                                    context.fillText(text, x, y);
                                };

                                // Join the fraud codes into a single string, separated by commas
                                const fraudCodeText = `Fraud Code: ${fraudCodes.join(',')}`;

                                // Draw the concatenated fraud code string with a border
                                // drawTextWithBorder(fraudCodeText, startX, startY);
                            };

                            const addWatermark = async (canvas, watermarkText1, watermarkText0, watermarkText2, watermarkText3, fraudCodes) => {
                                try {
                                    const watermarkLogo1 = `${process.env.PUBLIC_URL}/inspection-images/watermark-logo.png`;
                                    const logo = await preloadLogo(watermarkLogo1);

                                    return new Promise((resolve) => {

                                        const context = canvas.getContext('2d');

                                        // Set text properties
                                        context.font = '40px Mulish-Regular';
                                        context.textAlign = 'right';
                                        context.textBaseline = 'bottom';

                                        const textX = canvas.width - 20;
                                        const textYBase = canvas.height / 2 + 230;
                                        const textOffset = 50;

                                        // Define colors for text fill and stroke
                                        const fillColor = 'beige'; // Fill color for the text
                                        const strokeColor = 'gold'; // Border color for the text
                                        const lineWidth = 2; // Stroke width

                                        // Function to draw text with border
                                        const drawTextWithBorder = (text, x, y) => {
                                            // Set stroke style and draw the stroke
                                            context.strokeStyle = strokeColor;
                                            context.lineWidth = lineWidth;
                                            context.strokeText(text, x, y);

                                            // Set fill style and draw the filled text
                                            context.fillStyle = fillColor;
                                            context.fillText(text, x, y);
                                        };

                                        // Draw the watermarks
                                        drawTextWithBorder(watermarkText1, textX, textYBase);
                                        drawTextWithBorder(watermarkText0, textX, textYBase + textOffset);
                                        drawTextWithBorder(watermarkText2, textX, textYBase + textOffset * 2);
                                        drawTextWithBorder(watermarkText3, textX, textYBase + textOffset * 3);
                                        const logoWidth = canvas.width * 0.2;
                                        const logoHeight = logo.height / logo.width * logoWidth;
                                        const logoX = canvas.width - logoWidth - 20;
                                        const logoY = 15;
                                        const borderRadius = 70;

                                        context.fillStyle = 'rgba(25, 25, 25, 0.6)';
                                        context.beginPath();
                                        context.roundRect(logoX - 10, logoY - 10, logoWidth + 20, logoHeight + 5, borderRadius);
                                        context.fill();

                                        context.drawImage(logo, logoX, logoY, logoWidth, logoHeight);


                                        writeFraudCode(canvas, fraudCodes);
                                        resolve(canvas.toDataURL("image/jpeg", 0.95));
                                    });
                                } catch (error) {
                                    console.error('Error in addWatermark:', error);
                                }
                            };


                            const fraudCodes = ["0", "4", "3"]
                            // console.log(audit_id, item.image_name);
                            // const fraudCodes = fetchFraudCode(audit_id, item.image_name)
                            // Add watermark to the first canvas
                            const imgData1 = await addWatermark(canvas1, formattedTime, locationForTable0, locationForTable1, locationForTable2, fraudCodes);

                            // Add watermark to the second canvas
                            const imgData2 = await addWatermark(canvas2, formattedTime, locationForTable0, locationForTable1, locationForTable2, fraudCodes);

                            // Positioning the 2nd set of images on the same 
                            let newCurrentY;
                            if (tableHeight === 4) {
                                newCurrentY = currentY + tableHeight + 22
                            } else {
                                newCurrentY = currentY + tableHeight + 28
                            }

                            if (hasEnoughSpace(pdf, additionalDetails, currentY)) {
                                pdf.addImage(
                                    // canvas1.toDataURL("image/jpeg", 0.95),
                                    imgData1,
                                    "JPEG",
                                    paddingLeft,
                                    // currentY + tableHeight + 28,
                                    newCurrentY + 20,
                                    imgWidth1,
                                    imgHeight1 + 5
                                );
                                if (!['REGISTRATIONNO', 'REGISTRATION PLATE', 'CHASSIS', 'RC', 'ODOMETER', 'FRONT LEFT TYRE', 'BACK LEFT TYRE', 'BACK RIGHT TYRE', 'FRONT RIGHT TYRE', 'SELFIE'].includes(title)) {
                                    pdf.addImage(
                                        // canvas2.toDataURL("image/jpeg", 0.95),
                                        imgData2,
                                        "JPEG",
                                        // pageWidth - paddingRight - imgWidth1-22 + 5,
                                        paddingLeft + desiredWidth + 5,
                                        // currentY + tableHeight + 28,
                                        newCurrentY + 20,
                                        imgWidth2,
                                        imgHeight2 + 5
                                    );
                                }
                                if (tableHeight === 5) {
                                    currentY += Math.max(imgHeight1, imgHeight2) + 60;
                                }
                                else {
                                    currentY += Math.max(imgHeight1, imgHeight2) + 55;
                                }
                            }
                        }
                    }

                }
                // Add the disclaimer paragraph
                pdf.addImage("/inspection-images/disclaimer.png", paddingLeft + 7, 198 + addCounterY, 5, 5)
                const disclaimerParagraph1 = `This document is generated by an AI-supported system. For the purpose of claim settlement, the assessment of damages based on photographs will be considered conclusive regarding the car's condition during the Pre-inspection, taking precedence over any damage recorded in the report.`;

                const disclaimerLines1 = pdf.splitTextToSize(disclaimerParagraph1, pageWidth + 100);
                pdf.setFontSize(6);
                pdf.setFont("Mulish-Regular", "normal");
                pdf.text(disclaimerLines1, paddingLeft + 15, 200 + addCounterY);

                // Function to check if there's enough space on the page for additional details
                function hasEnoughSpace(pdf, additionalDetails, currentY) {
                    const tableHeight = additionalDetails.length * 5; // Adjust this value based on your table row height
                    const remainingHeight = pdf.internal.pageSize.height - (currentY + tableHeight);
                    return remainingHeight > 0;
                }
                // Function to add additional details to the current page
                function addAdditionalDetails(pdf, additionalDetails, paddingLeft, paddingTop) {
                    let height2;
                    if (additionalDetails.length === 3) {
                        height2 = 25;
                    } else {
                        height2 = 20;
                    }
                    let x2 = 10; // X position
                    let y2 = paddingTop + 10; // Y position
                    let width2 = 190; // Width of the rectangle
                    // Height of the rectangle
                    let radius2 = 1.5; // Corner radius

                    // Draw the filled rectangle with white background and shadow effect
                    pdf.setDrawColor(0, 0, 0, 0.13); // Shadow effect
                    pdf.setFillColor(255, 255, 255); // White background
                    pdf.roundedRect(x2, y2, width2, height2, radius2, radius2, 'FD');

                    // Draw the bottom border with a thicker line
                    pdf.setLineWidth(0.8); // Thicker border for bottom
                    pdf.line(x2, y2 + height2, x2 + width2, y2 + height2); // Bottom border

                    // Draw the top, left, and right borders with a thinner line
                    pdf.setLineWidth(0.005); // Thinner border for top, left, and right
                    pdf.line(x2, y2, x2 + width2, y2); // Top border
                    pdf.line(x2, y2, x2, y2 + height2); // Left border
                    pdf.line(x2 + width2, y2, x2 + width2, y2 + height2); // Right border

                    pdf.autoTable({
                        startY: paddingTop + 12,
                        body: additionalDetails,
                        theme: 'plain', // Removes the grid lines
                        margin: { left: paddingLeft, right: paddingLeft },
                        styles: {
                            textColor: 'black',
                            fontSize: 9,
                            lineWidth: 0 // Removes borders around cells
                        },
                        bodyStyles: {
                            halign: 'left',
                        },
                        columnStyles: {
                            0: { cellWidth: 'auto', font: 'Mulish-SemiBold' },
                            1: { cellWidth: 'auto', font: 'Mulish-Regular', },
                            2: { cellWidth: 'auto', font: 'Mulish-SemiBold' },
                            3: { cellWidth: 'auto', font: 'Mulish-Regular', }
                        }
                    });
                }
                pdf.save(`${result[0].audit_id}.pdf`);

                //save pdf to azure
                const pdfBlob = pdf.output('blob');

                // Convert Blob to Base64
                const reader = new FileReader();
                reader.readAsDataURL(pdfBlob);
                reader.onloadend = async () => {
                    const base64Pdf = reader.result.split(',')[1]; // Extract the base64 data part
                    try {
                        // Send the PDF content to the backend API
                        await axios.post('/process_data/upload-pdf', {
                            blobName,
                            pdfContent: base64Pdf,
                        });

                    } catch (error) {
                        console.error('Error uploading PDF to backend:', error);
                    }
                };



                let alert = {
                    snackbarOpen: true,
                    snackbarMessage: "PDF downloaded successfully !!",
                    snackbarMessageSeverity: "info",
                };
                dispatch(
                    setAlertMessageSnackbarMessageSeverity(alert.snackbarMessageSeverity)
                );
                dispatch(setAlertMessageSnackbarMsg(alert.snackbarMessage));
                dispatch(setAlertMessageSnackbarOpen(alert.snackbarOpen));
                setTimeout(() => {
                    dispatch(setAlertMessageSnackbarOpen(false));
                }, 5000);

            }
            catch (error) {
                let alert = {
                    snackbarOpen: true,
                    snackbarMessage: "Error generating PDF !!",
                    snackbarMessageSeverity: "error",
                };
                dispatch(
                    setAlertMessageSnackbarMessageSeverity(alert.snackbarMessageSeverity)
                );
                dispatch(setAlertMessageSnackbarMsg(alert.snackbarMessage));
                dispatch(setAlertMessageSnackbarOpen(alert.snackbarOpen));
                setTimeout(() => {
                    dispatch(setAlertMessageSnackbarOpen(false));
                }, 5000);
                console.error("Error generating PDF:", error);
            }
        }

    };

    const getCircleColor = (carDirection, type) => {
        // console.log(carDirection,"165")
        // if (carDirection === "Not detected") {
        //     // console.log(carDirection,type,"166");
        //     return "gray";
        // } else if (carDirection && type) {
        //     const matchedData = data.find(d => d.id.toString() === type)[0]?.name;
        //     if(type==="5" && carDirection === "rear")
        //     {
        //       return "green"
        //     }
        //     if (matchedData === carDirection) {
        //         return "green";
        //     }
        // }
        // // console.log(carDirection,type,"174");
        return "green";

    };

    const update_isAnnotated = async () => {
        try {
            const response = await axios.post("/miAuditSearch/update_annotation_flag", { audit_id: selectedAudit });
            //   console.log(response.data);
            toast.success("Annotation completed successfully!", {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } catch (err) {
            console.log(err, "error");
            toast.error("Error completing annotation.", {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };
    const handleDownload = useCallback(async () => {
        setIsDownloading(true);
        try {
            // console.log('Starting PDF download...');
            await downloadPDF(result); // Assuming downloadPDF returns a promise
            console.log('PDF download completed');
            await update_isAnnotated();
            console.log("updated");

            setPdfGenerated(true);

        } catch (error) {
            console.error('Download failed', error);
        } finally {
            setIsDownloading(false);
        }
    }, [result, downloadPDF]);


    useEffect(() => {
        // console.log('useEffect triggered', { result, pdfGenerated });

        if (result.length > 0 && !pdfGenerated && !isDownloading) {
            handleDownload();
        }
        else if (result.length > 0 && !pdfGenerated && !isDownloading) {
            setIsDownloading(false);
            setNotAnnotated(true);
        }
    }, [result, pdfGenerated, isDownloading, handleDownload]);

    return (
        <div >
            {/* <Topbar /> */}
            <div style={{ marginTop: "4rem", width: "100%" }}>
                {/* <div
					style={{
						display: "flex",
						justifyContent: "center",
						marginTop: "4rem",
						width: "100%",
					}}
				> */}
                {/* <button
						onClick={downloadPDF}
						style={{
							color: "black",
							background:
								"linear-gradient(white, white) padding-box, linear-gradient(60deg, #418ec6, green) border-box",
							padding: "0.5em 1em",
							border: "3px solid transparent",
							borderRadius: "10px",
							display: "inline-block",
							fontSize: "0.8rem",
							margin: "auto",
							fontFamily: "ChalkboardSE-Regular",
							cursor: "pointer",
							textTransform: "uppercase",
							// width: buttonWidth,
						}}
					>
						Download PDF
					</button> */}
                {/* </div> */}

                {isDownloading && (
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "1rem",
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        color: "#28a745",
                    }}>
                        <span>Downloading...</span>
                    </div>
                )}

                {notAnnotated && (
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "1rem",
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        color: "#dc3545",
                    }}>
                        <span>Unable to download the PDF. It may be that the audit has not been processed yet...</span>
                    </div>
                )}

                <div ref={targetRef}>
                    <Box
                        sx={{
                            margin: "auto",
                            marginTop: "1rem",
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-evenly",
                            flexWrap: "wrap",
                            gap: "2rem",
                            overflowX: "hidden",
                            marginBottom: "2rem",
                        }}
                    >
                        {result.length > 0 ? (
                            result.map((item, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-evenly",
                                        flexWrap: "wrap",
                                        gap: "5rem",
                                        width: "30%",
                                        overflowX: "hidden",
                                    }}
                                >
                                    {item.result.length > 0 ? (
                                        item.result.map((res, idx) =>
                                            res.category_id === 2 ? (
                                                <canvas
                                                    key={idx}
                                                    style={{ width: "100%", borderRadius: "0.5rem" }}
                                                    ref={(canvasRef) => {
                                                        if (canvasRef) {
                                                            const canvas = canvasRef;
                                                            const ctx = canvas.getContext("2d");
                                                            const boundingBoxes = [
                                                                {
                                                                    xMin: res.xmin,
                                                                    yMin: res.ymin,
                                                                    xMax: res.xmax,
                                                                    yMax: res.ymax,
                                                                    color: "red",
                                                                },
                                                            ];
                                                            const imageElement = new Image();
                                                            imageElement.crossOrigin = "anonymous"; // Set cross-origin attribute
                                                            imageElement.src = get_image_url(item.image_name);

                                                            imageElement.onload = () => {
                                                                const imageWidth = imageElement.width;
                                                                const imageHeight = imageElement.height;

                                                                canvas.width = imageWidth;
                                                                canvas.height = imageHeight;

                                                                ctx.drawImage(
                                                                    imageElement,
                                                                    0,
                                                                    0,
                                                                    imageWidth,
                                                                    imageHeight
                                                                );

                                                                boundingBoxes.forEach(
                                                                    ({ xMin, yMin, xMax, yMax, color }) => {
                                                                        const centerX = (xMin + xMax) / 2;
                                                                        const centerY = (yMin + yMax) / 2;
                                                                        const radius1 = 20;
                                                                        const radius4 = 80;
                                                                        ctx.globalAlpha = 0.4;
                                                                        const gradient = ctx.createRadialGradient(
                                                                            centerX,
                                                                            centerY,
                                                                            radius1,
                                                                            centerX,
                                                                            centerY,
                                                                            radius4
                                                                        );
                                                                        gradient.addColorStop(0, color);
                                                                        gradient.addColorStop(0.2, color);
                                                                        gradient.addColorStop(0.4, "yellow");
                                                                        gradient.addColorStop(0.6, "#388C04");
                                                                        gradient.addColorStop(1, "#00308f");

                                                                        ctx.fillStyle = gradient;
                                                                        ctx.beginPath();
                                                                        ctx.arc(
                                                                            centerX,
                                                                            centerY,
                                                                            radius4,
                                                                            0,
                                                                            2 * Math.PI
                                                                        );
                                                                        ctx.fill();
                                                                    }
                                                                );
                                                            };
                                                        }
                                                    }}
                                                />
                                            ) : (
                                                <span style={{ display: "none" }}>hh</span>
                                                // <h2>hh</h2>
                                            )
                                        )
                                    ) : (
                                        <canvas
                                            // key={idx}
                                            style={{ width: "100%", borderRadius: "0.5rem" }}
                                            ref={(canvasRef) => {
                                                if (canvasRef) {
                                                    const canvas = canvasRef;
                                                    const ctx = canvas.getContext("2d");

                                                    const imageElement = new Image();
                                                    imageElement.crossOrigin = "anonymous"; // Set cross-origin attribute
                                                    imageElement.src = get_image_url(item.image_name);

                                                    imageElement.onload = () => {
                                                        const imageWidth = imageElement.width;
                                                        const imageHeight = imageElement.height;

                                                        canvas.width = imageWidth;
                                                        canvas.height = imageHeight;

                                                        ctx.drawImage(
                                                            imageElement,
                                                            0,
                                                            0,
                                                            imageWidth,
                                                            imageHeight
                                                        );
                                                    };
                                                }
                                            }}
                                        />
                                    )}
                                </Box>
                            ))
                        ) : (
                            <div></div>
                        )}
                    </Box>
                </div>
            </div>
            <SnackbarAlert />
        </div>
    );


};

export default ProcessedResult;
